import CustomEvents from './customEvents';

const socketState = {
    "CONNECTING": 0,
    "OPEN": 1,
    "CLOSING": 2,
    "CLOSED": 3
};

export default class Comm {
    constructor(api, settings) {
        Object.assign(this, { api, settings });

        this.customEvents = new CustomEvents(this);
        this.openSocket();
    }

    sendLogs() {
        for (let key in localStorage) {
            if (!localStorage.hasOwnProperty(key)) continue;

            if (key.indexOf("clientLog_") === 0) {
                let log = localStorage[key],
                    meta = key.split("_");

                this.sendSocketMsg({
                    "type": "clientLog",
                    "data": {
                        "gameBridgeUUID": this.api.gb.uuid,
                        "loggerLevel": meta[3],
                        "time": new Date(+meta[1]).toISOString(),
                        "log": log
                    }
                });
                localStorage.removeItem(key);
            }
        }
        this.sendLogsTimeout = setTimeout(() => {
            this.sendLogs();
        }, 5000);
    }

    openSocket(reconnect) {
        logger.info(reconnect === true ? "Socket reconnecting ..." : "Socket opening ...");
        window._game_bridge_socket = this.socket = new WebSocket(this.settings.socketUrl);

        this.socket.onopen = () => {
            logger.info(reconnect === true ? "Socket reconnected" : "Socket opened");
            if (reconnect === true && this.getReconnectToken()) {
                this.socketReconnect();
            } else {
                this.socketAuth();
            }

            this.registeredInstances = {};
            this.openingSocket = null;

            // if localStorage not awailable (in incognito mode), browser will throw an error when reading localStore ...
            if (this.api.gb.utils.isLocalStorageAvailable === true) {
                this.sendLogs();
            } else if (this.api.gb.settings.nativeMobileApp){
                this.sendNativeAppLog()
            }
        };

        this.socket.onmessage = (msg) => {
            let payload = msg.data;
            try {
               payload = JSON.parse(payload);
            }catch (e) {
                // already an object
            }

            logger.debug("Socket IN", payload);

            if (payload.type === "ping") {
                this.sendSocketMsg({
                    "type": "ping_response"
                });

                return;
            }

            if (payload.type === "auth_response") {
                if (payload.data) {

                    if (!payload.data.reconnectToken) {
                        logger.info("No reconnect token in socket!");
                    }

                    this.setReconnectToken(payload.data.reconnectToken);

                    if (payload.data.loggerLevel) {
                        this.api.gb.setLoggerLevel(payload.data.loggerLevel, true);
                    }

                    if (payload.data.currencyCode) {
                        this.api.gb.setCurrencyCode(payload.data.currencyCode)
                    }
                }
                if (payload.error) {
                    let err = payload.error;
                    try {
                        err = JSON.parse(err);
                    } catch (e) {}

                    logger.debug("Socket 'auth' failed!", err);
                    if (err && err.code && err.code === "DENIED") {
                        this.stopReconnecting = true;
                    }
                }
                return;
            }

            if (payload.type === "reconnect_response") {
                if (payload.data) {
                    this.setReconnectToken(payload.data.reconnectToken);
                    window.dispatchEvent(new CustomEvent("oryx_register_instance"));
                }
                if (payload.error) {
                    let err = payload.error;
                    try {
                        err = JSON.parse(err);
                    } catch (e) {}

                    logger.debug("Socket 'reconnect' failed!", err);
                    if (err && err.code && err.code === "DENIED") {
                        this.stopReconnecting = true;
                    }
                }
                return;
            }

            this.customEvents.dispatchEvent(payload);
        };

        this.socket.onclose = (event) => {
            logger.info('Socket closing ...', event);
            this.socket = null;
            this.openingSocket = null;

            if (this.stopReconnecting !== true) {
                setTimeout(() => {
                    this.openSocket(true);
                }, 3000);
            }
        };

        this.socket.onerror = (event) => {
            logger.debug('Error occured on socket connection', event);
            this.socket.close();
        };
    }

    sendSocketMsg(msg) {
        let type = msg.type;
        if (typeof msg !== "string") {
            msg = JSON.stringify(msg);
        }

        if (type !== "clientLog") {
            logger.debug("Socket OUT", msg);
        }
        
        if (this.socket) {
            this.socket.send(msg);
        }
        

    }

    setReconnectToken(token) {
        this.reconnectToken = token;
    }

    getReconnectToken() {
        return this.reconnectToken;
    }

    socketAuth() {
        let data = {
            "cageCode" : this.settings.cageCode,
            "lngCode3": this.settings.languageCode,
            "gameGroupCode": this.settings.gameGroupCode,
            "componentType": "GAME-BRIDGE"
        };

        if (this.settings.playerId) {
            data.walletPlayerIdentifier = this.settings.playerId;  // remove later ... not needed
            data.playerId = this.settings.playerId;
        }
        if (this.settings.token) {
            data.token = this.settings.token;
        }

        if (this.settings.nativeMobileApp) {
            data.nativeMobileApp = this.settings.nativeMobileApp;
        }

        this.sendSocketMsg({
            "type": "auth",
            "data": data
        });

        if (this.api.gb.version) {
            let payload = {
                module: 'game_bridge',
                version : this.api.gb.version
            }

            this.sendSocketMsg({
                "type": "version",
                "data": payload
            });
        }
    }

    socketReconnect() {
        this.sendSocketMsg({
            "type": "reconnect",
            "data": {
                "reconnectToken": this.getReconnectToken()
            }
        });
    }

    registerInstance(options) {
        if (this.socket.readyState === socketState.OPEN) {
            if (this.registeredInstances[`${options.module}_${options.instance}`] && options.force !== true) {
                // already registered on this socket ... do nothing
                return;
            }
     
            this.registeredInstances[`${options.module}_${options.instance}`] = {
                ts: new Date().toISOString(),
                status: "PENDING" // not a server status ... artificial status for api purposes ... will get overwritten later by a correct status returned from server
            };

            this.sendSocketMsg({
                "type": "registerInstance",
                "module": options.module,
                "instance": options.instance,
                "data": options.data
            });

            // this.customEvents.dispatchEvent({
            //     ...this.api.drawer,
            //     type: "append_widget_container",
            //     inst: {
            //         module: options.module,
            //         instance: options.instance
            //     }
            // });

        } else if (this.socket.readyState === socketState.CONNECTING) {
            setTimeout(() => {
                this.registerInstance(options);
            }, 100);
        }
    }

    nativeAppLog(data) {
        this.dataLog = data
    }

    sendNativeAppLog() {
        if (this.dataLog) {
            this.sendSocketMsg(
                {
                    "type": "clientLog",
                    "data": {
                        "time": new Date().toISOString(),
                        ...(this.dataLog)
                    }
                });
        }
    }
}
